module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corona_australis/cra_names-576f35858c35c94ee3a95185825d1562.gif";